import * as ApiClient from '@/libs/ApiClient';
import type { AxiosResponse } from 'axios';
import { RouteUrlList } from '@/libs/RouteList';

/**
 * 刪除已上傳檔案請求參數
 */
export interface IDeleteUploadedFileParams {
    /** 關聯的上傳項目ID (第2層項目) */
    itemID: number;
    /** 已上傳檔案fileHash */
    fileHash: string;
}

/**
 * 刪除已上傳檔案回應
 */
export interface IDeleteUploadedFileResponse {
    /** 回應狀態 */
    status: boolean;
    /** 錯誤代碼 */
    code: number;
    /** 例外訊息 */
    exception: string | null;
    /** 訊息 */
    message: string | null;
    /** 被刪除的文件 ID 列表 (GUID) */
    result: string[] | null;
}

/**
 * FileUpload - 刪除已上傳的檔案 API
 *
 * @description 刪除指定上傳項目的已上傳檔案
 * @param params 刪除檔案請求參數
 * @returns Promise<IDeleteUploadedFileResponse>
 */
export async function DeleteUploadedFile(params: IDeleteUploadedFileParams): Promise<IDeleteUploadedFileResponse> {
    const url = RouteUrlList.API_DeleteUploadedFile.path;
    const config = {
        params: {
            showOverlay: ApiClient.paramTypeEnum.true,
            getServiceAlert: ApiClient.paramTypeEnum.true
        }
    };

    return await ApiClient.post(url, params, config).then((res: AxiosResponse<IDeleteUploadedFileResponse>) => {
        return res.data;
    });
}

export default DeleteUploadedFile;
